export default __webpack_public_path__ + "static/media/2.2bb51edb.jpg";